module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Sea Import")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Container Load"
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryTerms", $$v)
      },
      expression: "ffExoprtDetail.deliveryTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("De-Stuffing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeName,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingType", $$v)
      },
      expression: "ffExoprtDetail.stuffingType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getagentName,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "agentName", $$v)
      },
      expression: "ffExoprtDetail.agentName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "importerClientId", $$v)
      },
      expression: "ffExoprtDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.importerClientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "exporterName"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.exporterClientId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "bookingParty"
    }
  }, [_vm._v("Booking Party")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.bookingPartyList,
      "option-value": "billingPartyVal",
      "option-text": "billingPartyTxt",
      "placeholder": "Select Booking Party"
    },
    model: {
      value: (_vm.ffExoprtDetail.bookingParty),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "bookingParty", $$v)
      },
      expression: "ffExoprtDetail.bookingParty"
    }
  })], 1), _vm._v(" "), (_vm.ffExoprtDetail.bookingParty == 'Other') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.bookingParty == 'Other') ? _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name (Booking Party)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.sourceOriginclientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "sourceOriginclientId", $$v)
      },
      expression: "ffExoprtDetail.sourceOriginclientId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.containerInfo == 'lcl') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("CoLoader Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getColoaderNameList,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Coloader "
    },
    model: {
      value: (_vm.ffExoprtDetail.coLoaderName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "coLoaderName", $$v)
      },
      expression: "ffExoprtDetail.coLoaderName"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.coLoaderName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorListLCL.coLoaderName))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "placeOfReceipt",
      "name": "placeOfReceipt"
    },
    model: {
      value: (_vm.ffExoprtDetail.placeOfReceipt),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "placeOfReceipt", $$v)
      },
      expression: "ffExoprtDetail.placeOfReceipt"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadPort",
      "name": "loadPort",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.loadPort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "loadPort", $$v)
      },
      expression: "ffExoprtDetail.loadPort"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "portOfDischarge",
      "name": "portOfDischarge"
    },
    model: {
      value: (_vm.ffExoprtDetail.portOfDischarge),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "portOfDischarge", $$v)
      },
      expression: "ffExoprtDetail.portOfDischarge"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place Of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "finalPlaceDelivery",
      "name": "finalPlaceDelivery"
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceDelivery),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceDelivery", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceDelivery"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("SOB Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "sailDate",
      "name": "sailDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.sailDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "sailDate", $$v)
      },
      expression: "ffExoprtDetail.sailDate"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.sailDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.sailDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Pre-Alert Received Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "alertReceivedDate",
      "name": "alertReceivedDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.alertReceivedDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "alertReceivedDate", $$v)
      },
      expression: "ffExoprtDetail.alertReceivedDate"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.alertReceivedDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.alertReceivedDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("IGM Manifestation Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "not-after": new Date(),
      "id": "igmManifestationDate",
      "name": "igmManifestationDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.igmManifestationDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "igmManifestationDate", $$v)
      },
      expression: "ffExoprtDetail.igmManifestationDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Vessel ETA Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "vesselEtaDate",
      "name": "vesselEtaDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.vesselEtaDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "vesselEtaDate", $$v)
      },
      expression: "ffExoprtDetail.vesselEtaDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Days at India Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "freeDaysIndiaPort",
      "name": "freeDaysIndiaPort",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ffExoprtDetail.freeDaysIndiaPort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "freeDaysIndiaPort", $$v)
      },
      expression: "ffExoprtDetail.freeDaysIndiaPort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Handling Fees By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.destiHandleList,
      "option-value": "DHVal",
      "option-text": "DHText",
      "placeholder": "Select Destination Handling Fees By"
    },
    model: {
      value: (_vm.ffExoprtDetail.destinationHandling),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "destinationHandling", $$v)
      },
      expression: "ffExoprtDetail.destinationHandling"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "firstBLNumber",
      "name": "firstBLNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLNumber", $$v)
      },
      expression: "ffExoprtDetail.firstBLNumber"
    }
  })], 1), _vm._v(" "), (!_vm.ffExoprtDetail.firstBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.firstBLNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "firstBlType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ffExoprtDetail.containerInfo == 'fcl' ?
        _vm.blTypeList :
        _vm.blTypeListLcl,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type",
      "isDisabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBlType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBlType", $$v)
      },
      expression: "ffExoprtDetail.firstBlType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("B/L Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "firstBLDate",
      "name": "firstBLDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLDate", $$v)
      },
      expression: "ffExoprtDetail.firstBLDate"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.firstBLDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.firstBLDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Ocean Freight")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.oceanFreightTermsList,
      "option-value": "oceanFreightTermsVal",
      "option-text": "oceanFreightTermsText",
      "placeholder": "Select Ocean Freight"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstOcFreghtTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstOcFreghtTerms", $$v)
      },
      expression: "ffExoprtDetail.firstOcFreghtTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "id": "permitted1",
      "name": "permitted1",
      "md-value": "Original"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLRadio", $$v)
      },
      expression: "ffExoprtDetail.firstBLRadio"
    }
  }, [_vm._v("Original")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "seaWayBl"
    },
    model: {
      value: (_vm.ffExoprtDetail.firstBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "firstBLRadio", $$v)
      },
      expression: "ffExoprtDetail.firstBLRadio"
    }
  }, [_vm._v("Sea Way B/L")]), _vm._v(" "), (!_vm.ffExoprtDetail.firstBLRadio) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.firstBLRadio))]) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload B/L")])], 1), _vm._v(" "), (_vm.firstBlUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }), _vm._v(" "), _vm._l((_vm.firstBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.firstBLRadio == 'Original') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Surrender Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "secondBLDate",
      "name": "secondBLDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.surrenderDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "surrenderDate", $$v)
      },
      expression: "ffExoprtDetail.surrenderDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Original BL Received Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "originalBlRecDate",
      "name": "originalBlRecDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.originalBlRecDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "originalBlRecDate", $$v)
      },
      expression: "ffExoprtDetail.originalBlRecDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.ffExoprtDetail.notifyList), function(singleInputM, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Name & Address")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotifyMaster(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "inputValue",
        "name": "inputValue"
      },
      model: {
        value: (singleInputM.inputValue),
        callback: function($$v) {
          _vm.$set(singleInputM, "inputValue", $$v)
        },
        expression: "singleInputM.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.addNotifyMaster
    }
  }, [_vm._v("Add More Notify")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('div', [(
    _vm.getHouseBLData.length == 0 ||
    _vm.openShipper == true ||
    _vm.HouseBLModel.houseBLId != ''
  ) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('b-card', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "secondBLNumber",
      "name": "secondBLNumber"
    },
    model: {
      value: (_vm.HouseBLModel.secondBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBLNumber", $$v)
      },
      expression: "HouseBLModel.secondBLNumber"
    }
  })], 1), _vm._v(" "), (!_vm.HouseBLModel.secondBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.HouseBLModelError.secondBLNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondBlType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ffExoprtDetail.containerInfo == 'fcl' ?
        _vm.blTypeList :
        _vm.blTypeListLcl,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type"
    },
    model: {
      value: (_vm.HouseBLModel.secondBlType),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBlType", $$v)
      },
      expression: "HouseBLModel.secondBlType"
    }
  }), _vm._v(" "), (!_vm.HouseBLModel.secondBlType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.HouseBLModelError.secondBlType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("B/L Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "secondBLDate",
      "name": "secondBLDate"
    },
    model: {
      value: (_vm.HouseBLModel.secondBLDate),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBLDate", $$v)
      },
      expression: "HouseBLModel.secondBLDate"
    }
  }), _vm._v(" "), (!_vm.HouseBLModel.secondBLDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.HouseBLModelError.secondBLDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.HouseBLModel.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "50"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Name &\n                          Address")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "85"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "inputValue",
        "name": "inputValue"
      },
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add More Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondOcFreghtTerms"
    }
  }, [_vm._v("Ocean Freight")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.oceanFreightTermsList,
      "option-value": "oceanFreightTermsVal",
      "option-text": "oceanFreightTermsText",
      "placeholder": "Select Ocean Freight"
    },
    model: {
      value: (_vm.HouseBLModel.secondOcFreghtTerms),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondOcFreghtTerms", $$v)
      },
      expression: "HouseBLModel.secondOcFreghtTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "id": "permitted1",
      "name": "permitted1",
      "md-value": "Original"
    },
    model: {
      value: (_vm.HouseBLModel.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBLRadio", $$v)
      },
      expression: "HouseBLModel.secondBLRadio"
    }
  }, [_vm._v("Original")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "seaWayBl"
    },
    model: {
      value: (_vm.HouseBLModel.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBLRadio", $$v)
      },
      expression: "HouseBLModel.secondBLRadio"
    }
  }, [_vm._v("Sea Way B/L")]), _vm._v(" "), (!_vm.HouseBLModel.secondBLRadio) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.HouseBLModelError.secondBLRadio))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "secondBLupload",
      "id": "secondBLupload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChange('SECOND')
      }
    },
    model: {
      value: (_vm.HouseBLModel.secondBLupload),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "secondBLupload", $$v)
      },
      expression: "HouseBLModel.secondBLupload"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.secondBlUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }), _vm._v(" "), _vm._l((_vm.secondBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.HouseBLModel.secondBLRadio == 'Original') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Surrender Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "secondBLDate",
      "name": "secondBLDate"
    },
    model: {
      value: (_vm.HouseBLModel.surrenderDate),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "surrenderDate", $$v)
      },
      expression: "HouseBLModel.surrenderDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Original BL Received Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "originalBlRecDate",
      "name": "originalBlRecDate"
    },
    model: {
      value: (_vm.HouseBLModel.originalBlRecDate),
      callback: function($$v) {
        _vm.$set(_vm.HouseBLModel, "originalBlRecDate", $$v)
      },
      expression: "HouseBLModel.originalBlRecDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-2",
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.HouseBLModel.houseBLId == "" ? "Add" : "Update") + "\n                      BL")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader3"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getHouseBLData.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("House-BL Details")])], 1), _vm._v(" "), (
    _vm.getHouseBLData.length > 0 && _vm.HouseBLModel.houseBLId == ''
  ) ? _c('md-button', {
    staticClass: "md-fab md-fab pull-right",
    staticStyle: {
      "height": "10px",
      "width": "39px"
    },
    on: {
      "click": _vm.showMoreShipper
    }
  }, [(_vm.openShipper == false) ? _c('md-icon', [_vm._v("add")]) : _c('md-icon', [_vm._v("cancel")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "FreghtContaner"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("B/L Number")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Ocean Freight Terms")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getHouseBLData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.editHouseBL(item1)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item1.secondBLNumber) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.secondBLRadio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.secondOcFreghtTerms))])])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("Custom Clearance Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccOutSourced),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccOutSourced", $$v)
      },
      expression: "ffExoprtDetail.ccOutSourced"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.ccOutSourced == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccChaName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccChaName", $$v)
      },
      expression: "ffExoprtDetail.ccChaName"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("Transportation Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select TPT Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.tptOutSource),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptOutSource", $$v)
      },
      expression: "ffExoprtDetail.tptOutSource"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.tptOutSource == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tptChaName",
      "name": "tptChaName"
    },
    model: {
      value: (_vm.ffExoprtDetail.tptChaName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptChaName", $$v)
      },
      expression: "ffExoprtDetail.tptChaName"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.shippingId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gateway IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "preCarriageBy",
      "name": "preCarriageBy"
    },
    model: {
      value: (_vm.ffExoprtDetail.gateWayIgmNo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "gateWayIgmNo", $$v)
      },
      expression: "ffExoprtDetail.gateWayIgmNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Gateway IGM Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "gatewayIgmDate",
      "name": "gatewayIgmDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.gatewayIgmDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "gatewayIgmDate", $$v)
      },
      expression: "ffExoprtDetail.gatewayIgmDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voyage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoyage",
      "name": "vesselVoyage"
    },
    model: {
      value: (_vm.ffExoprtDetail.vesselVoyage),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "vesselVoyage", $$v)
      },
      expression: "ffExoprtDetail.vesselVoyage"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Vessel Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "gatewayIgmDate",
      "name": "gatewayIgmDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.vesselArrivalDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "vesselArrivalDate", $$v)
      },
      expression: "ffExoprtDetail.vesselArrivalDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showLocalIgmDiv == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Local IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "preCarriageBy",
      "name": "preCarriageBy"
    },
    model: {
      value: (_vm.ffExoprtDetail.localIgmNo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "localIgmNo", $$v)
      },
      expression: "ffExoprtDetail.localIgmNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Local IGM Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "gatewayIgmDate",
      "name": "gatewayIgmDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.localIgmDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "localIgmDate", $$v)
      },
      expression: "ffExoprtDetail.localIgmDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": _vm.addSameDateRadio
    },
    model: {
      value: (_vm.allSame),
      callback: function($$v) {
        _vm.allSame = $$v
      },
      expression: "allSame"
    }
  }, [_vm._v("Port ETA Date,CFS Arrival Date,Free Days Upto is\n                  Same")])], 1)], 1), _vm._v(" "), (_vm.multiContainer.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.(AAAA1234567)")]), _vm._v(" "), _c('th', [_vm._v("Container Type/Size")]), _vm._v(" "), _c('th', [_vm._v("\n                      " + _vm._s(_vm.showLocalIgmDiv == false ?
    "Port ETA Date" :
    "Rail Out Date") + "\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                      " + _vm._s(_vm.showLocalIgmDiv == false ?
    "CFS Arrival Date" :
    "ICD Arrival Date") + "\n                    ")]), _vm._v(" "), _c('th', [_vm._v("Free Days Upto")])]), _vm._v(" "), _vm._l((_vm.multiContainer), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "maxlength": "11"
      },
      on: {
        "keyup": function($event) {
          _vm.containerNoRegexfun(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].ContainerNo),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "ContainerNo", $$v)
        },
        expression: "multiContainer[index].ContainerNo"
      }
    }), _vm._v(" "), (_vm.multiContainer[index].ContainerNo != '') ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.containerNoRegexError[index]))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": "",
        "list": _vm.ContainerTypeList,
        "option-value": "containerTypeId",
        "option-text": "containerType",
        "placeholder": "Select Container Type"
      },
      model: {
        value: (_vm.multiContainer[index].ContainerType),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "ContainerType", $$v)
        },
        expression: "multiContainer[index].ContainerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "railOutDate",
        "name": "railOutDate"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].railOutDate),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "railOutDate", $$v)
        },
        expression: "multiContainer[index].railOutDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "arrivalDate",
        "name": "arrivalDate"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].arrivalDate),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "arrivalDate", $$v)
        },
        expression: "multiContainer[index].arrivalDate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "freeDays",
        "name": "freeDays"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].freeDays),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "freeDays", $$v)
        },
        expression: "multiContainer[index].freeDays"
      }
    })], 1)])
  })], 2)])]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }, [_c('label', [_vm._v("Commodity Name, HSN Code and Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "commodity",
      "name": "commodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodity", $$v)
      },
      expression: "ffExoprtDetail.commodity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryMode", $$v)
      },
      expression: "ffExoprtDetail.deliveryMode"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.ffExoprtDetail.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remarks", $$v)
      },
      expression: "ffExoprtDetail.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Documents")])], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('0')
      }
    }
  }, [_vm._v("Save & Submit")])], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('1')
      }
    }
  }, [_vm._v("Save and Proceed to Payment Detail")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddSeaImp
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "message",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9bdd760","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/seaImport/ffseaImportFcl.vue
// module id = 2860
// module chunks = 0